import React from 'react';
import { CBadge, CCard, CCardBody, CCol, CRow } from '@coreui/react';
import Detail from '../../components/micro/Detail';
import _t from 'counterpart';
import { useQuery } from 'react-query';
import { getPersonalInfo } from '../../services/BackendService';
import CenteredSpinner from '../../components/CenteredSpinner';
import { formatDate } from '../../helpers';

export const PersonalInformationTab = ({ customerId }: { customerId: string }) => {
  const personalInfoQuery = useQuery(['personal-info', customerId], () => getPersonalInfo(customerId));

  const personalInfo = personalInfoQuery.data;
  if (personalInfoQuery.isLoading) {
    return <CenteredSpinner />;
  }

  const isBoolOrNull = (validateVar: boolean | null) => {
    if (validateVar === undefined || validateVar === null) {
      return '-';
    } else {
      if (validateVar === true) {
        return <CBadge color="success">{_t('global.yes')}</CBadge>;
      } else {
        return <CBadge color="danger">{_t('global.no')}</CBadge>;
      }
    }
  };
  return (
    <CCard>
      <CCardBody>
        <CRow>
          <CCol md={6}>
            <dl>
              <Detail title={_t('customer.personal-information.nationality')}>
                {personalInfo?.nationality || '-'}
              </Detail>
              <Detail title={_t('customer.personal-information.country-of-residence')}>
                {personalInfo?.countryOfResidence || '-'}
              </Detail>
              <Detail title={_t('customer.personal-information.id-or-passport-number')}>
                {personalInfo?.idOrPassportNumber || '-'}
              </Detail>
              <Detail title={_t('customer.personal-information.is-pep')}>
                {personalInfo ? isBoolOrNull(personalInfo.isPep) : '-'}
              </Detail>
              <Detail title={_t('customer.personal-information.is-us-citizen-or-tax')}>
                {personalInfo ? isBoolOrNull(personalInfo.isUsCitizenOrTaxResident) : '-'}
              </Detail>
            </dl>
          </CCol>
          <CCol md={6}>
            <dl>
              <Detail title={_t('customer.personal-information.city')}>{personalInfo?.city || '-'}</Detail>
              <Detail title={_t('customer.personal-information.address')}>{personalInfo?.address || '-'}</Detail>
              <Detail title={_t('customer.personal-information.zip-code')}>{personalInfo?.zipCode || '-'}</Detail>
              <Detail title={_t('customer.personal-information.date-of-birth')}>
                {personalInfo?.dateOfBirth ? formatDate(new Date(personalInfo?.dateOfBirth)) : '-'}
              </Detail>
            </dl>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};
